export const CALCULATE = 'calculate';
export const PAYMENT = 'payment';
export const MANAGE = 'manage';
